import { NgModule, inject } from '@angular/core';
import { RouterModule } from '@angular/router';

import { APP_ROUTES } from './app-routing.routes';
import { RouterConfigService } from './router-config.service';

@NgModule({
  imports: [
    RouterModule.forRoot(APP_ROUTES, {
      scrollPositionRestoration: 'enabled',
      anchorScrolling: 'enabled',
      paramsInheritanceStrategy: 'always',
      initialNavigation: 'enabledBlocking'
    })
  ],
  exports: [RouterModule]
})
export class AppRoutingModule {
  // instantiation by injection
  private readonly configService = inject(RouterConfigService);
}
